import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Form } from 'antd';
import useFetchQuery from '../../../../hooks/useFetchQuery';
import BookingContext from './BookingContext';

function BookingContextProvider({ children }) {
    const { masseusesId } = useParams();

    const [formatTime, setFormatTime] = useState('12h');

    const [formInstance] = Form.useForm();

    const masseuseIdForm = Form.useWatch('masseuse_id', formInstance);
    const lat = Form.useWatch('lat', formInstance);
    const long = Form.useWatch('long', formInstance);

    const { data: servicesOptions, isLoading: isLoadingServiceOptions } = useFetchQuery({
        enabled: () => masseusesId || masseuseIdForm,
        url: `/masseuses/${masseusesId || masseuseIdForm}/services`,
        method: 'get',
        onFetchSuccess: (data) => {
            return data?.data?.services?.map((item) => ({
                ...item,
                label: item?.name,
                value: item?.id,
            }));
        },
    });

    const { data: therapistOptions, isLoading: isLoadingTherapistOptions } = useFetchQuery({
        url: '/masseuses/nearby',
        enabled: () => !masseusesId && lat && long,
        payload: {
            cursor: 0,
            lat,
            limit: 20,
            lng: long,
            hide_unavailable: true,
        },
        onFetchSuccess: (data) => {
            return data?.data?.masseuses?.map((item) => ({
                ...item,
                label: item?.full_name,
                value: item?.id,
            }));
        },
    });

    const { data: detailTherapist, isLoading: isLoadingDetailTherapist } = useFetchQuery({
        url: `/masseuses/${masseusesId}/brief`,
        method: 'get',
        onFetchSuccess: (data) => {
            return data?.data;
        },
    });

    const contextValue = useMemo(() => {
        return {
            detailTherapist,
            isLoadingDetailTherapist,
            therapistOptions,
            isLoadingTherapistOptions,
            servicesOptions,
            isLoadingServiceOptions,
            setFormatTime,
            formatTime,
            formInstance,
        };
    }, [
        detailTherapist,
        isLoadingDetailTherapist,
        therapistOptions,
        isLoadingTherapistOptions,
        servicesOptions,
        isLoadingServiceOptions,
        setFormatTime,
        formatTime,
        formInstance,
    ]);

    return <BookingContext.Provider value={contextValue}>{children}</BookingContext.Provider>;
}

export default BookingContextProvider;
